var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      { staticClass: "col-12" },
      [
        _c("table-data", {
          directives: [{ name: "validate", rawName: "v-validate" }],
          attrs: {
            data: _vm.value,
            settings: _vm.table.settings,
            columns: _vm.table.columns,
            inlineFilters: _vm.table.filters,
            autoUpdateFilter: _vm.table.autoUpdateFilter,
            addParamsToUrl: _vm.table.addParamsToUrl,
            loadingMsg: _vm.table.loadingMsg,
            notFoundMsg: _vm.table.notFoundMsg,
            orderByTemplate: _vm.table.orderByTemplate,
            showPagination: _vm.table.showPagination,
            tableInline: _vm.table.tableInline,
            name: "users",
          },
          on: { "error-load": _vm.showError },
          scopedSlots: _vm._u(
            [
              !_vm.readonlyFormItem
                ? {
                    key: "title",
                    fn: function () {
                      return [
                        _c("div", { staticClass: "row" }, [
                          _c(
                            "div",
                            { staticClass: "col-12" },
                            [
                              _c(
                                "MaterialSelect",
                                {
                                  staticClass: "city-form-group city-bg",
                                  attrs: {
                                    size: "small",
                                    label: "name",
                                    ajaxOptions: {
                                      url: _vm.url.getUsers,
                                    },
                                    reduce: (option) => option,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "option",
                                        fn: function ({ option }) {
                                          return [
                                            _c("strong", [
                                              _vm._v(_vm._s(option.name)),
                                            ]),
                                            _c("br"),
                                            _vm._v(
                                              _vm._s(option.email) +
                                                "\n                            "
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "grpAppend",
                                        fn: function () {
                                          return [
                                            _c(
                                              "button",
                                              {
                                                staticClass: "btn btn-main",
                                                attrs: {
                                                  disabled: !_vm.user,
                                                  type: "button",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.preventDefault()
                                                    return _vm.addUser.apply(
                                                      null,
                                                      arguments
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                    " +
                                                    _vm._s(
                                                      _vm.$t(
                                                        `${_vm.pageID}.form.add_user`
                                                      )
                                                    ) +
                                                    "\n                                "
                                                ),
                                              ]
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    848921558
                                  ),
                                  model: {
                                    value: _vm.user,
                                    callback: function ($$v) {
                                      _vm.user = $$v
                                    },
                                    expression: "user",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(
                                        _vm.$t(
                                          `${_vm.pageID}.form.placeholder_user`
                                        )
                                      ) +
                                      "\n                            "
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    },
                    proxy: true,
                  }
                : null,
              {
                key: "body",
                fn: function ({ row, index, remove }) {
                  return [
                    _c("td", { class: _vm.table.columns[0].class }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(row.name) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("td", { class: _vm.table.columns[1].class }, [
                      _vm._v(
                        "\n                    " +
                          _vm._s(row.email) +
                          "\n                "
                      ),
                    ]),
                    _vm._v(" "),
                    _vm.checkActions
                      ? _c("column-actions", {
                          attrs: {
                            deleteMsgTemplate: _vm.$t(
                              `${_vm.pageID}.form.delete_user`,
                              { name: row.name }
                            ),
                            canDetail: false,
                            canEdit: false,
                            canDelete: _vm.canDelete,
                            row: row,
                            index: index,
                            callbackDelete: remove,
                          },
                          on: { delete: _vm.deleteUser },
                        })
                      : _vm._e(),
                  ]
                },
              },
            ],
            null,
            true
          ),
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }